var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"is-show":_vm.isShowPosterModal},on:{"hideModal":_vm.hidePosterModal}},[_c('div',{staticClass:"poster-modal"},[_c('div',{staticClass:"head"},[_c('span',[_vm._v("分享海报")])]),_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.activityConfig.shareImgUrl}})]),_c('div',{staticClass:"text"},[_c('span',[_vm._v("长按保存图片")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }